import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/LoginScreen.css';

declare global {
  interface Window {
    google: any;
  }
}

const LoginScreen: React.FC = () => {
  const { login } = useAuth();

  React.useEffect(() => {
    // Load Google Identity Services script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    const handleCredentialResponse = async (response: any) => {
      try {
        await login(response.credential);
      } catch (error) {
        console.error('Login error:', error);
      }
    };

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
        });

        window.google.accounts.id.renderButton(
          document.getElementById('googleSignInButton'),
          {
            theme: 'outline',
            size: 'large',
            text: 'signin_with',
            shape: 'rectangular',
          }
        );
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [login]);

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Video Upload App</h1>
        <p>Sign in with your Google account to upload and manage videos</p>
        <div id="googleSignInButton" className="google-signin-button"></div>
        <div className="features">
          <div className="feature">
            <h3>🎥 Upload Videos</h3>
            <p>Easily upload your videos to secure cloud storage</p>
          </div>
          <div className="feature">
            <h3>📋 Manage Library</h3>
            <p>View and organize your uploaded video collection</p>
          </div>
          <div className="feature">
            <h3>▶️ Stream Anywhere</h3>
            <p>Watch your videos from any device with internet access</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;